interface AdminEnv {
  supabaseUrl: string;
  supabaseAnonKey: string;
  appName: string;
  defaultLocale: string;
}

function required(key: string, value: string | undefined): string {
  if (!value) throw new Error(`Missing required env var ${key}`);
  return value;
}

export const env: AdminEnv = {
  supabaseUrl: required('VITE_SUPABASE_URL', import.meta.env.VITE_SUPABASE_URL),
  supabaseAnonKey: required('VITE_SUPABASE_ANON_KEY', import.meta.env.VITE_SUPABASE_ANON_KEY),
  appName: import.meta.env.VITE_APP_NAME ?? 'MoniGo Admin',
  defaultLocale: import.meta.env.VITE_DEFAULT_LOCALE ?? 'fr',
};
